// extracted by mini-css-extract-plugin
module.exports = {"gallery":"styles_gallery__9Np3c","thumbnails":"styles_thumbnails__xceye","carousel":"styles_carousel__pA4sj","avatar":"styles_avatar__R1kJi","current":"styles_current__kD8KQ"};